import * as React from "react";
import { useRef } from "react";
import { AvatarUserInfo } from "./Avatar";
import "./UserIdentity.scss";
import { buildClasses } from "../../utils/classes";
import UserCardRegular from "./UserCardRegular";
import { createRoot } from "react-dom/client";

interface Impersonation {
  isImpersonating: boolean;
  logbackUrl: string;
  crsfParameterName: string;
  crsfToken: string;
}

export default function UserIdentity({
  impersonation,
  userCard,
}: {
  impersonation: Impersonation;
  userCard: AvatarUserInfo;
}) {
  const impersonateFormRef = useRef<HTMLFormElement>();

  return (
    <div
      className={buildClasses(
        {
          ["impersonating-panel"]: () => impersonation.isImpersonating,
        },
        "identity-panel"
      )}
    >
      <UserCardRegular
        upperSection={
          impersonation.isImpersonating && (
            <div className={"informative-text"}>
              {i18n["Global.Identity.Impersonating.Message"]}
            </div>
          )
        }
        userInfo={userCard}
      />
      {impersonation.isImpersonating && (
        <div className="impersonating-action centered">
          <a className="link" href="#" onClick={() => impersonateFormRef.current.submit()}>
            {i18n["Global.Identity.Impersonate.Stop"]}
          </a>
          <form ref={impersonateFormRef} method="post" action={impersonation.logbackUrl}>
            <input
              type="hidden"
              name={impersonation.crsfParameterName}
              value={impersonation.crsfToken}
            />
          </form>
        </div>
      )}
    </div>
  );
}

UserIdentity.loadComponent = (elementClass: string, props) => {
  const elements = document.getElementsByClassName(elementClass);
  Array.from(elements).forEach((element) => {
    const root = createRoot(element);
    root.render(<UserIdentity {...props} />);
  });
};
